// External libraries
import React from 'react';
import { BankLogo } from '@checkout/react-components';

// Internal modules
import { getLocale } from '@/lib/globals';
import {
  CardArtContainer,
  CardIconContainer,
  CardItem,
  CardList,
  SvgWrapper,
} from '../styledComponents';
import { CardIconsBarLoadingElement } from '../Components';
import { useSupportedFundingSourcesQuery } from './graphql';
import { formatDebitAndCreditCardTypes } from './utils';
import { logger } from '@/lib';
const sgvStyle = {
  backgroundColor: 'white',
  borderRadius: '3px',
  paddingBottom: '63.15%',
};

const DebitCardIconsBar = () => {
  const { loading, error, data } = useSupportedFundingSourcesQuery();
  if (loading) {
    return <CardIconsBarLoadingElement />;
  }

  if (error) {
    // render nothing when there is error
    logger.warn(`cannot_fetch_debit_card_for_${getLocale().country}`, {
      error,
    });
    return null;
  }

  const debitAndCreditCards = formatDebitAndCreditCardTypes(
    data.checkoutSession,
  );

  // we don't show the card bar if server returns nothing
  if (debitAndCreditCards.length === 0) {
    return null;
  }

  return (
    <CardIconContainer data-testid="debit-card-icons-bar">
      <CardList>
        {debitAndCreditCards.map(issuer => {
          return (
            <CardItem key={issuer.name}>
              <CardArtContainer>
                {/* The padding-bottom style is required to be inline */}
                <SvgWrapper style={sgvStyle}>
                  <BankLogo
                    bankName={issuer.name}
                    image={{
                      rank: issuer.rank,
                      url: issuer.issuerLogoUrl.href,
                    }}
                    key={issuer.name}
                  />
                </SvgWrapper>
              </CardArtContainer>
            </CardItem>
          );
        })}
      </CardList>
    </CardIconContainer>
  );
};

export { DebitCardIconsBar };
